export default {"src":"/_next/static/media/option-card-effect-orange.fcb3bda2.svg","height":220,"width":220,"blurWidth":0,"blurHeight":0};